<template>
  <div>
    <ActionBar>
      <el-button slot="action" type="danger" plain @click="back">
        กลับ
      </el-button>
      <el-button slot="action" type="primary" @click="confirm">
        ยืนยัน
      </el-button>
      <ActionBarTitle>{{ pageTitle }}</ActionBarTitle>
    </ActionBar>

    <PageContainer>
      <AppContainer>
        <el-row type="flex" :gutter="32" :style="{ flexWrap: 'wrap' }">
          <el-col :sm="12">
            <el-card header="รายการ">
              <div :style="{ marginBottom: '1.5rem' }">
                <ClientProfileDisplay :style="{ marginBottom: '0.5rem' }" :avatar="customer && customer.avatar"
                  :name="customer && customer.fullName" :tel="customer && customer.tel" />

                <el-row type="flex" :gutter="32" :style="{ flexWrap: 'wrap', marginBottom: '0.5rem' }">
                  <el-col :sm="12">
                    <span :style="{ fontWeight: 'bold', marginRight: '0.5em' }">วันที่ขาย</span>{{ form.date |
                    $_datetime_thaiDatetime }}
                  </el-col>
                  <el-col :sm="12">
                    <span :style="{ fontWeight: 'bold', marginRight: '0.5em' }">เลขที่ใบรับประกัน</span>{{
                    form.warrantyCardNo }}
                  </el-col>
                </el-row>
              </div>

              <PaymentList header="รายการทองลูกค้า" :style="{ marginBottom: '1.5rem' }">
                <PaymentListItem v-for="(item, index) in form.customer.items" :key="index" :title="item.product.name"
                  :value="item.price">
                  <template #value="value">
                    <div :style="{ fontSize: '1.25rem' }">
                      {{ value }}
                    </div>
                  </template>
                  {{ item.product.percent | $_number_percent }} / น้ำหนักทอง
                  {{ item.weight | $_number_formattedNumber }} บาท ,
                  {{ item.realWeight | $_number_formattedNumber }} กรัม
                </PaymentListItem>
                <PaymentListDivider></PaymentListDivider>
                <PaymentListItem title="รวม" :value="form.customer.totalPrice">
                  <template #title="title">
                    <div :style="{ fontSize: '1.125rem', fontWeight: 'bold' }">
                      {{ title }}
                    </div>
                  </template>
                </PaymentListItem>
              </PaymentList>

              <PaymentList header="รายการขายทอง" :style="{ marginBottom: '1.5rem' }">
                <PaymentListItem v-for="(item, index) in form.store.items" :key="index" :title="item.product.name"
                  :value="item.total(+form.store.discount / 100)">
                  <template #value="value">
                    <div :style="{ fontSize: '1.25rem' }">
                      {{ value }}
                    </div>
                  </template>
                  {{ item.product.percent | $_number_percent }} / น้ำหนักทอง
                  {{ item.weight | $_number_formattedNumber }} บาท ,
                  {{ item.realWeight | $_number_formattedNumber }}
                  กรัม / ค่ากำเหน็จ
                  {{ item.charge | $_number_formattedNumber }} บาท
                </PaymentListItem>
                <PaymentListDivider></PaymentListDivider>
                <PaymentListItem title="รวม" :value="form.store.total">
                  <template #title="title">
                    <div :style="{ fontSize: '1.125rem', fontWeight: 'bold' }">
                      {{ title }}
                    </div>
                  </template>
                </PaymentListItem>
              </PaymentList>

              <PaymentList header="สรุป" :style="{ marginBottom: '1.5rem' }">
                <PaymentListItem title="รายการซื้อทอง" :value="form.customer.totalPrice">
                  <template #title="title">
                    <div :style="{ fontSize: '1.125rem', fontWeight: 'bold' }">
                      {{ title }}
                    </div>
                  </template>
                  <template #value="value">
                    <div :style="{ fontSize: '1.25rem' }">
                      {{ value }}
                    </div>
                  </template>
                </PaymentListItem>
                <PaymentListItem title="รายการขายทอง" :value="form.store.total">
                  <template #title="title">
                    <div :style="{ fontSize: '1.125rem', fontWeight: 'bold' }">
                      {{ title }}
                    </div>
                  </template>
                  <template #value="value">
                    <div :style="{ fontSize: '1.25rem' }">
                      {{ value }}
                    </div>
                  </template>
                </PaymentListItem>
                <PaymentListDivider></PaymentListDivider>
                <PaymentListItem :title="summaryTitle" :value="Math.abs(form.customer.totalPrice - form.store.total)">
                  <template #title="title">
                    <div :style="{ fontSize: '1.125rem', fontWeight: 'bold' }">
                      {{ title }}
                    </div>
                  </template>
                </PaymentListItem>
              </PaymentList>

              <PaymentNote v-if="form.note">
                {{ form.note }}
              </PaymentNote>
            </el-card>
          </el-col>
          <el-col :sm="12">
            <el-card :header="paymentTitle">
              <StorePayment v-if="payer === 'store'" :amount="form.customer.totalPrice - form.store.total"
                :methods="paymentForm.methods" :evidences="paymentForm.evidences" :uploading="isUploading"
                :change.sync="change" @add-method="addPaymentMethod" @remove-method="removePaymentMethod"
                @upload="handleFileUpload" @remove-evidence="removeEvidence"></StorePayment>
              <CustomerPayment v-else-if="payer === 'customer'" :amount="form.store.total - form.customer.totalPrice"
                :discount.sync="paymentForm.discount" :invoice.sync="paymentForm.invoice" :methods="paymentForm.methods"
                :evidences="paymentForm.evidences" :uploading="isUploading" :change.sync="change"
                @add-method="addPaymentMethod" @remove-method="removePaymentMethod" @upload="handleFileUpload"
                @remove-evidence="removeEvidence"></CustomerPayment>
            </el-card>
          </el-col>
        </el-row>
      </AppContainer>
    </PageContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { datetimeMixin, numberMixin } from '@/mixins'
import { FileService } from '@/services'
import { useEvidence } from '@/use/evidence'
import {
  ActionBar,
  //ActionBarButton,
  ActionBarTitle
} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import {
  PaymentList,
  PaymentListItem,
  PaymentListDivider
} from '@/components/page/payment-list'
import { PaymentNote } from '@/components/page/payment-note'
import { showPrintDialog } from '@/components/dialog/receipt'
import { ClientProfileDisplay } from '@/components/page/client-profile'
import { StorePayment } from '@/components/page/store-payment'
import { CustomerPayment } from '@/components/page/customer-payment'
import { useLoading } from '../../use/loading'
import { back } from '@/utils/navigation'

export default {
  components: {
    ActionBar,
    //ActionBarButton,
    ActionBarTitle,
    PageContainer,
    AppContainer,
    PaymentList,
    PaymentListItem,
    PaymentListDivider,
    PaymentNote,
    ClientProfileDisplay,
    StorePayment,
    CustomerPayment
  },

  mixins: [datetimeMixin, numberMixin],

  data() {
    return {
      isUploading: false,
      change: 0
    }
  },

  computed: {
    ...mapGetters('trade', ['customer', 'form', 'paymentForm', 'payer']),

    pageTitle() {
      switch (this.payer) {
        case 'customer':
          return 'แลกเปลี่ยนทอง บันทึกรายรับ'

        case 'store':
          return 'แลกเปลี่ยนทอง บันทึกรายจ่าย'
      }

      return null
    },

    summaryTitle() {
      switch (this.payer) {
        case 'customer':
          return 'ยอดเงินที่ต้องชำระเพิ่ม'

        case 'store':
          return 'ยอดเงินที่ต้องจ่ายให้ลูกค้า'
      }

      return null
    },

    paymentTitle() {
      switch (this.payer) {
        case 'customer':
          return 'ยอดเงินที่รับชำระ'

        case 'store':
          return 'ยอดเงินจ่ายออก'
      }

      return null
    }
  },

  created() {
    if (!this.paymentForm) {
      this.createPaymentForm()
    }
  },

  methods: {
    ...mapActions('trade', [
      'createPaymentForm',
      'addPaymentMethod',
      'removePaymentMethod',
      'addEvidence',
      'removeEvidence',
      'validatePaymentForm',
      'reset',
      'createReceipt'
    ]),

    back() {
      back({ name: 'TradeCreate' })
    },

    async confirm() {
      const createReceipt = async () => {
        const loading = useLoading()

        try {
          return await this.createReceipt()
        } catch (err) {
          throw new Error(err.message)
        } finally {
          loading.close()
        }
      }

      const showPrint = async (id, change) => {
        const type = { customer: 'sell', store: 'buy' }[this.payer]
        const action = await showPrintDialog({
          change: change,
          changeHeader: 'เงินทอน/เงินคืน'
        })

        switch (action) {
          case 'slip':
            return window.open(
              this.$router.resolve({
                name: 'TradePrint',
                params: { id: id, type: type }
              }).href
            )
        }
      }

      const reset = async () => {
        const loading = useLoading()

        try {
          await this.reset()
        } catch (err) {
          throw new Error(err.message)
        } finally {
          loading.close()
        }
      }

      try {
        await this.validatePaymentForm()

        try {
          const { id } = await createReceipt()
          await showPrint(id, this.change)
          await this.$router.push({ name: 'Home' })
          await reset()
        } catch (err) {
          this.$notify.error(err.message)
        }
      } catch (err) {
        this.$message.warning('กรุณาตรวจสอบข้อมูลชำระเงิน')
      }
    },

    async handleFileUpload(files) {
      this.isUploading = true

      const promises = files
        .filter(file => {
          if (!/^image\/.+|application\/pdf$/.test(file.type)) {
            this.$message.warning(`${file.name} ไม่สามารถอัปโหลดได้`)
            return false
          }
          return true
        })
        .map(
          async file =>
            await FileService.create(file)
              .then(res => res.data)
              .then(({ status, result }) => {
                if (status === 'error') {
                  throw new Error(`${file.name} มีปัญหาในการอัปโหลด`)
                }

                return result
              })
              .then(({ id, attachment }) => {
                this.addEvidence(useEvidence({ id, url: attachment }))

                this.$message.success(`อัปโหลด ${file.name} เรียบร้อยแล้ว`)
              })
              .catch(err => {
                this.$message.error(err.message)
              })
        )

      await Promise.all(promises)

      this.isUploading = false
    }
  }
}
</script>
